module.exports = __webpack_public_path__ + "img/4_65.df380aff.png";